import { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';

const AlternativeProposalModal = ({
    show,
    onClose,
    onSubmit,
    loading,
    motorcycleOptions = [],
}) => {
    const [shopMotorcycleId, setShopMotorcycleId] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [message, setMessage] = useState('');

    useEffect(() => {
        if (show) {
            setShopMotorcycleId('');
            setStartDate('');
            setEndDate('');
            setMessage('');
        }
    }, [show]);

    const handleSubmit = () => {
        onSubmit({
            shopMotorcycleId: shopMotorcycleId || null,
            startDate: startDate || null,
            endDate: endDate || null,
            message: message.trim(),
        });
    };

    return (
        <Modal show={show} onHide={onClose} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Offer an alternative</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <p className="text-muted">
                    This will not change the booking status. The proposal will be saved in
                    booking history and can be sent to the customer.
                </p>

                <Form.Group className="mb-3">
                    <Form.Label>Alternative motorcycle</Form.Label>
                    <Form.Select
                        value={shopMotorcycleId}
                        onChange={(e) => setShopMotorcycleId(e.target.value)}
                    >
                        <option value="">Select a motorcycle</option>
                        {motorcycleOptions.map((item) => (
                            <option key={item.value} value={item.value}>
                                {item.label}
                            </option>
                        ))}
                    </Form.Select>
                </Form.Group>

                <div className="row">
                    <div className="col-md-6">
                        <Form.Group className="mb-3">
                            <Form.Label>Alternative start date</Form.Label>
                            <Form.Control
                                type="date"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                            />
                        </Form.Group>
                    </div>

                    <div className="col-md-6">
                        <Form.Group className="mb-3">
                            <Form.Label>Alternative end date</Form.Label>
                            <Form.Control
                                type="date"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                            />
                        </Form.Group>
                    </div>
                </div>

                <Form.Group>
                    <Form.Label>Message</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={4}
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        placeholder="Explain the alternative option"
                    />
                </Form.Group>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={onClose} disabled={loading}>
                    Close
                </Button>
                <Button
                    variant="warning"
                    onClick={handleSubmit}
                    disabled={!shopMotorcycleId && !message.trim() && !startDate && !endDate}
                >
                    Save Proposal
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AlternativeProposalModal;